import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import Button from "../../components/Buttons";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getBlogsQuery,
    handleEditClick,
    handleWorkDelete,
    handleAddBlogClick,
  } = useBlogsProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <div className="flex justify-end" onClick={handleAddBlogClick}>
        <div className="bg-[black] p-1 rounded-full w-auto cursor-pointer">
          <Plus className="text-[white]" />
        </div>
      </div>
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[20rem]">
                Title
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                Description
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                Keywords
              </th>
              <th className="border font-normal border-gray-300 text-left w-[70px] px-4">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {getBlogsQuery?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="border border-gray-300 px-2 py-2">
                  <Label
                    className="mb-0 text-black text-[15px]"
                    label={item.name}
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2">
                  <Label
                    className="mb-0 text-[15px]"
                    label={item.position}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <Label
                    className="mb-0 w-60 truncate overflow-hidden text-ellipsis whitespace-nowrap text-[15px]"
                    label={item.review}
                  />
                </td>
                <td className="flex justify-between border border-gray-300 bg-white text-center py-4">
                  <Pencil
                    className="ml-4 cursor-pointer"
                    onClick={() => handleEditClick(item)}
                  />
                  <Trash
                    className="mr-4 cursor-pointer"
                    onClick={() => handleWorkDelete(item)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="absolute bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
        <Button type="submit">Save</Button>
      </div>
    </Section>
  );
}
